import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  CraComment,
  CreateCraComment,
  UpdateCraComment,
} from "../models/CraComment";

export const CraCommentApi = {
  get: async (commentId: string) => {
    return await jwtAuthAxios().get<CraComment>(`/cra-comments/${commentId}`);
  },

  create: async (comment: CreateCraComment) => {
    return await jwtAuthAxios().post<CraComment>(`/cra-comments`, comment);
  },

  update: async (commentId: string, body: UpdateCraComment) => {
    return await jwtAuthAxios().put<CraComment>(
      `/cra-comments/${commentId}`,
      body
    );
  },

  resolve: async (commentId: string) => {
    return await jwtAuthAxios().put<CraComment>(
      `/cra-comments/${commentId}/resolve`
    );
  },

  unresolve: async (commentId: string) => {
    return await jwtAuthAxios().put<CraComment>(
      `/cra-comments/${commentId}/unresolve`
    );
  },

  delete: async (commentId: string) => {
    return await jwtAuthAxios().delete<CraComment>(
      `/cra-comments/${commentId}`
    );
  },
};
